module.exports = "/static/assets/49ba9617d58a3e29df87ade0f5a9ff6e.svg";